@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;

.itemCard {
    align-items: flex-start;
    background-color: $itemBackgroundColor;
    border-radius: rem(8px);
    gap: rem(12px);
    padding: rem(16px) rem(26px);
}
